import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import DatePickerController from '../../components/common/controller/DatePickerController';
import { useForm } from 'react-hook-form';
import { nextStep, setFormData } from '../../redux/slice/findJobSlice';
import Button from '../../components/general/Button';
import { toast } from 'react-toastify';
import { ArrowUpRight } from '../../components/common/Icons';


const StepFourForm = () => {
    const min = new Date().getFullYear() - 40;
    const max = new Date().getFullYear();
    const dispatch = useDispatch();
    const total_experience = useSelector(state => state.findJob.stepFourData.total_experience);

    const { control, setValue, watch, handleSubmit } = useForm({
        defaultValues: { total_experience }
    });

    const year = max - watch("total_experience");
    
    const handleFormSubmit = () => {
        handleSubmit((data) => {
            dispatch(setFormData({ formData: data }))
            dispatch(nextStep())
        })()
    }

    return (
        <div className='min-h-[60vh] !py-[50px] !pb-[50px] lg:flex lg:justify-between'>
            <div className=''>
                <div>
                    <p className='text-primary-color'> 4/8 </p>
                    <h1 className="text-[1.6rem] font-semibold">
                        <span> When did your </span>
                        {/* <Image src={DoubleStar} alt="double-star" className="hidden lg:inline-block" /> */}
                        <span className='lg:block'>commercial experience start?</span>
                    </h1>
                </div>

                <div className='hidden lg:block mt-[20px] text-[#2A2A2A]'>
                    <div className='mt-[20px]'>
                        <p> 5/8 </p>
                        <h1 className="text-[1.6rem] font-semibold">
                            <span> Choose your main </span>
                            <span className='lg:block'> technologies?</span>
                        </h1>
                    </div>
                    <div className='mt-[20px]'>
                        <p> 6/8 </p>
                        <h1 className="text-[1.6rem] font-semibold">
                            <span> Add your experience </span>
                            <span className='lg:block'> highlights </span>
                        </h1>
                    </div>
                </div>
            </div>

            <div className='lg:w-[55%]'>
                <div className='hidden lg:flex gap-[20px] text-[13px] mb-[50px] lg:justify-center'>
                    <p className='text-primary-color'> 1. Project Preferences </p>
                    <p className='text-primary-color'> 2. Specialization in stack </p>
                    <p className='text-primary-color'> 3. Additional info </p>
                    <p> 4. Registration </p>
                </div>

                <div className='text-[15px] mb-[30px]'>
                    <div className='flex items-center justify-center gap-[10px] text-[#797979]'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 hidden lg:block">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                        </svg>

                        <div className='text-left lg:text-center'>
                            Recall when you received money for your first project, we guess it's
                        </div>
                    </div>
                    <div className='text-left lg:text-center text-[#797979]'>
                        when your commercial experience started
                    </div>
                </div>
                <div className='flex flex-col gap-4 mt-[20px] w-full'>
                    <div>
                        <label className='block text-primary-color mb-[10px]'> Experience since </label>
                        <DatePickerController
                            yearPicker
                            name="total_experience"
                            showYearPicker
                            control={control}
                            className="form-control"
                            dateFormat="YYYY"
                            maxDate={new Date(max, 0, 1)}
                        />
                        <input
                            className='block mt-[40px] w-full accent-primary-color'
                            type="range"
                            min={min}
                            max={max}
                            name="total_experience"
                            value={watch("total_experience")}
                            onChange={(e) => {
                                setValue("total_experience", Number(e.target.value))
                            }}
                        />

                        <p className='text-primary-color text-[13px] mt-[10px] text-right'> {year} years </p>
                    </div>
                </div>
                <Button onClick={handleFormSubmit} className='w-full bg-primary-color text-black h-[40px] lg:h-[50px] text-[1rem] lg:text-[1rem] lg:mx-auto rounded mt-[20px] md:w-[200px] lg:mt-[50px]' disabled={!Boolean(watch("total_experience"))}>
                  <div className="flex items-center justify-center gap-2">
                    <span>Ok, next</span>
                    <ArrowUpRight className="w-4 h-4" />
                  </div>
                </Button>
            </div>
        </div>
    )
}

export default StepFourForm